import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\SmartSearchController::index
* @see app/Http/Controllers/Admin/SmartSearchController.php:33
* @route '/admin/ai/smart-search'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/admin/ai/smart-search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::index
* @see app/Http/Controllers/Admin/SmartSearchController.php:33
* @route '/admin/ai/smart-search'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::index
* @see app/Http/Controllers/Admin/SmartSearchController.php:33
* @route '/admin/ai/smart-search'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::index
* @see app/Http/Controllers/Admin/SmartSearchController.php:33
* @route '/admin/ai/smart-search'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::index
* @see app/Http/Controllers/Admin/SmartSearchController.php:33
* @route '/admin/ai/smart-search'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::index
* @see app/Http/Controllers/Admin/SmartSearchController.php:33
* @route '/admin/ai/smart-search'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::index
* @see app/Http/Controllers/Admin/SmartSearchController.php:33
* @route '/admin/ai/smart-search'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::settings
* @see app/Http/Controllers/Admin/SmartSearchController.php:74
* @route '/admin/ai/smart-search/settings'
*/
export const settings = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: settings.url(options),
    method: 'put',
})

settings.definition = {
    methods: ["put"],
    url: '/admin/ai/smart-search/settings',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::settings
* @see app/Http/Controllers/Admin/SmartSearchController.php:74
* @route '/admin/ai/smart-search/settings'
*/
settings.url = (options?: RouteQueryOptions) => {
    return settings.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::settings
* @see app/Http/Controllers/Admin/SmartSearchController.php:74
* @route '/admin/ai/smart-search/settings'
*/
settings.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: settings.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::settings
* @see app/Http/Controllers/Admin/SmartSearchController.php:74
* @route '/admin/ai/smart-search/settings'
*/
const settingsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::settings
* @see app/Http/Controllers/Admin/SmartSearchController.php:74
* @route '/admin/ai/smart-search/settings'
*/
settingsForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: settings.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

settings.form = settingsForm

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::texts
* @see app/Http/Controllers/Admin/SmartSearchController.php:99
* @route '/admin/ai/smart-search/texts'
*/
export const texts = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: texts.url(options),
    method: 'put',
})

texts.definition = {
    methods: ["put"],
    url: '/admin/ai/smart-search/texts',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::texts
* @see app/Http/Controllers/Admin/SmartSearchController.php:99
* @route '/admin/ai/smart-search/texts'
*/
texts.url = (options?: RouteQueryOptions) => {
    return texts.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::texts
* @see app/Http/Controllers/Admin/SmartSearchController.php:99
* @route '/admin/ai/smart-search/texts'
*/
texts.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: texts.url(options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::texts
* @see app/Http/Controllers/Admin/SmartSearchController.php:99
* @route '/admin/ai/smart-search/texts'
*/
const textsForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: texts.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::texts
* @see app/Http/Controllers/Admin/SmartSearchController.php:99
* @route '/admin/ai/smart-search/texts'
*/
textsForm.put = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: texts.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

texts.form = textsForm

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::exportMethod
* @see app/Http/Controllers/Admin/SmartSearchController.php:119
* @route '/admin/ai/smart-search/export'
*/
export const exportMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

exportMethod.definition = {
    methods: ["get","head"],
    url: '/admin/ai/smart-search/export',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::exportMethod
* @see app/Http/Controllers/Admin/SmartSearchController.php:119
* @route '/admin/ai/smart-search/export'
*/
exportMethod.url = (options?: RouteQueryOptions) => {
    return exportMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::exportMethod
* @see app/Http/Controllers/Admin/SmartSearchController.php:119
* @route '/admin/ai/smart-search/export'
*/
exportMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::exportMethod
* @see app/Http/Controllers/Admin/SmartSearchController.php:119
* @route '/admin/ai/smart-search/export'
*/
exportMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: exportMethod.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::exportMethod
* @see app/Http/Controllers/Admin/SmartSearchController.php:119
* @route '/admin/ai/smart-search/export'
*/
const exportMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::exportMethod
* @see app/Http/Controllers/Admin/SmartSearchController.php:119
* @route '/admin/ai/smart-search/export'
*/
exportMethodForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\SmartSearchController::exportMethod
* @see app/Http/Controllers/Admin/SmartSearchController.php:119
* @route '/admin/ai/smart-search/export'
*/
exportMethodForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: exportMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

exportMethod.form = exportMethodForm

const smartSearch = {
    index: Object.assign(index, index),
    settings: Object.assign(settings, settings),
    texts: Object.assign(texts, texts),
    export: Object.assign(exportMethod, exportMethod),
}

export default smartSearch